import { render, staticRenderFns } from "./TextFieldBox.vue?vue&type=template&id=089718bf&scoped=true&"
import script from "./TextFieldBox.vue?vue&type=script&lang=ts&"
export * from "./TextFieldBox.vue?vue&type=script&lang=ts&"
import style0 from "./TextFieldBox.vue?vue&type=style&index=0&id=089718bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089718bf",
  null
  
)

export default component.exports